/** @format */

import { CartEDD, EDDv2, ModernEDD } from '@cart-checkout/data-access/interfaces';
import { CustomHttpHeaders, MediaType } from '@shared/data-access/enums';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { DCSG_CONSTANTS } from '@shared/data-access/constants';
import { Environment } from '@shared/data-access/interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EddDao {
  private readonly http = inject(HttpClient);
  private readonly environment = inject(Environment);

  /**
   * @description Get EDD Dates
   * @param checkoutKey string
   * @param submitted boolean
   */
  public getShippingInformation$(checkoutKey: string, submitted: boolean) {
    let url = `${this.environment.api.checkout.basePath}/${checkoutKey}/shipping/information`;
    if (submitted) {
      url += '?submitted=true';
    }

    const httpHeaders = new HttpHeaders({
      Accept: MediaType.APPLICATION_JSON,
      'Content-Type': MediaType.APPLICATION_JSON,
      'Access-Control-Allow-Origin': '*',
      'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
      Pragma: 'no-cache',
      'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.short}`,
    });

    const httpOptions = {
      headers: httpHeaders,
      withCredentials: true,
    };

    return this.http.get<any>(url, httpOptions);
  }

  /**
   * @description Get estimated delivery dates. Replaced /shipping/information
   * @param checkoutKey string
   * @param zipCode string
   * @param submitted boolean
   * @returns Edd object containing estimated delivery dates
   */
  public getEstimatedDeliveryDates$(
    checkoutKey: string,
    submitted: boolean,
    zipCode: string,
  ): Observable<EDDv2 | ModernEDD> {
    let url = `${this.environment.api.checkout.basePath}/${checkoutKey}/edd`;

    // zipcode/submitted stuff here
    if (submitted) {
      url += '?submitted=true';
    } else if (zipCode) {
      url += `?zipCode=${zipCode}`;
    }

    const httpHeaders = new HttpHeaders({
      Accept: MediaType.APPLICATION_JSON,
      'Content-Type': MediaType.APPLICATION_JSON,
      'Access-Control-Allow-Origin': '*',
      'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
      Pragma: 'no-cache',
      'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.short}`,
    });

    const httpOptions = {
      headers: httpHeaders,
      withCredentials: true,
    };

    httpOptions.headers = this.setDefaultModernHttpHeaders(httpOptions);

    return this.http.get<EDDv2>(url, httpOptions);
  }

  public getCartEDD(checkoutKey: string, zipCode: string) {
    const url = `${this.environment.api.checkout.basePath}/${checkoutKey}/edd?zipCode=${zipCode}`;

    const httpHeaders = new HttpHeaders({
      Accept: MediaType.APPLICATION_JSON,
      'Content-Type': MediaType.APPLICATION_JSON,
      'Access-Control-Allow-Origin': '*',
      'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
      Pragma: 'no-cache',
      'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.short}`,
    });

    const httpOptions = {
      headers: httpHeaders,
      withCredentials: true,
    };

    return this.http.get<CartEDD>(url, httpOptions);
  }

  private setDefaultModernHttpHeaders(request: any): HttpHeaders {
    let httpHeaders = request.headers;
    httpHeaders = httpHeaders.set(CustomHttpHeaders.X_CHK_MOD, 'true');
    httpHeaders = httpHeaders.set(CustomHttpHeaders.CHK, '2');
    return httpHeaders;
  }
}
